import React, { useState, useEffect } from "react";
import "../css/Slider.css";
import { Link } from "react-router-dom";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "images/pre.jpg",
      title: "Welcome to Sahara Public",
      subtitle: "Empowering students to reach their full potential.",
      linkTo: "/about",
    },
    {
      image: "images/primary.jpg",
      title: "Quality Education",
      subtitle: "Focusing on academic excellence and holistic development.",
      linkTo: "/school-level",
    },
    {
      image: "images/n.jpeg",
      title: "Modern Infrastructure",
      subtitle: "Safe and inspiring environment for future leaders.",
      linkTo: "/Student-life",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="slider-container">
      {slides.map((slide, index) => {
        const isActive = index === currentSlide;

        return (
          <Link
            to={slide.linkTo}
            key={index}
            className={`slide ${isActive ? "active" : ""}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${slide.image})`,
              display: isActive ? "flex" : "none",
            }}
          >
            {isActive && (
              <div className="slide-content">
                <h1>{slide.title}</h1>
                <p>{slide.subtitle}</p>
                {}
                <span className="slider-btn">Learn More</span>
              </div>
            )}
          </Link>
        );
      })}

      {}
      <div className="slider-dots" onClick={(e) => e.stopPropagation()}>
        {slides.map((_, index) => (
          <span
            key={index}
            className={index === currentSlide ? "dot active-dot" : "dot"}
            onClick={(e) => {
              e.preventDefault();
              setCurrentSlide(index);
            }}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Slider;
